module.exports = __webpack_public_path__ + "assets/img/4yby.80dbd49c.png";